import { ThemeProvider } from "@emotion/react";
import theme from "../../style/theme";
import { EditableMaterilIcon, MaterialIcon } from "../../classes/materialIcon";
import { Button, Card, CardHeader, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControlLabel, IconButton, TextField, Tooltip } from "@mui/material";
import { EditableText, MultilingualEditableText } from "../textFields";
import { useTranslation } from "react-i18next";
import { idRegex } from "../../utils/regex";
import { ArrowDownwardOutlined, ArrowUpwardOutlined, DeleteOutline } from "@mui/icons-material";
import { SolutionPrice } from "../../classes/solution.tsx";
import { useState } from "react";

export function PriceDialog({ open, onClose, onEdit, onEndEditing, onUpdate, price, language='en', canEdit=true, languages=['en'], isEditing=false, showPopUp=()=>{} }) {
    const { t } = useTranslation();

    return <Dialog
        open={open}
        onClose={onClose}
        disableEscapeKeyDown
    >
        {open
            ? <div className={`solution-pricing-card ${price.getActive() ? 'solution-featured' : ''}}`} style={{position: 'relative', '--primary': theme.palette.primary.main, '--secondary': theme.palette.secondary.main}}>
                <MultilingualEditableText id='editing-price-title' texts={price.getTitle()} languages={languages} displayLanguage={language} tag="h3" canEdit={canEdit} onSave={(value) => {
                    price.setTitle(value);
                    onUpdate();
                }} onStartEditing={onEdit} onEnd={onEndEditing}/>
                <div className={`solution-price ${price.getSecondary() !== undefined ? 'has-secondary' : ''}`}><MultilingualEditableText id="editing-price-primary-value" texts={price.getPrimary().getValue()} languages={['eur']} displayLanguage="eur" tag="div" canEdit={canEdit} onSave={(value)=>{
                    price.getPrimary().setValue(value);
                    onUpdate();
                }} onStartEditing={onEdit} onEnd={onEndEditing}/><span>/<MultilingualEditableText id="editing-price-primary-period" texts={price.getPrimary().getPeriod()} languages={languages} displayLanguage={language} tag="div" canEdit={canEdit} onSave={(value)=>{
                    price.getPrimary().setPeriod(value);
                    onUpdate();
                }} onStartEditing={onEdit} onEnd={onEndEditing}/></span></div>
                <Divider/>
                {price.getSecondary() !== undefined
                    ? <>
                        <div style={{
                            display: 'flex',
                            flexFlow: 'row',
                            flexWrap: 'nowrap',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '5px',
                            width: '100%',
                        }}>
                            <div className="solution-price-secondary" style={{marginBottom: 0, maxWidth: '80%'}}>
                                <MultilingualEditableText id="editing-price-primary-value" texts={price.getSecondary().getValue()} languages={['eur']} displayLanguage="eur" tag="div" canEdit={canEdit} onSave={(value)=>{
                                    price.getSecondary().setValue(value);
                                    onUpdate();
                                }} onStartEditing={onEdit} onEnd={onEndEditing}/><span>/<MultilingualEditableText id="editing-price-primary-period" texts={price.getSecondary().getPeriod()} languages={languages} displayLanguage={language} tag="div" canEdit={canEdit} onSave={(value)=>{
                                    price.getSecondary().setPeriod(value);
                                    onUpdate();
                            }} onStartEditing={onEdit} onEnd={onEndEditing}/></span></div>
                            {canEdit
                                ? <Tooltip title={t('solutions.page.pricing.actions.deleteSecondary')}><IconButton onClick={()=>{
                                    if (!isEditing) {
                                        price.setSecondary(undefined);
                                        onUpdate();
                                    } else {
                                        showPopUp();
                                    }
                                }}><DeleteOutline/></IconButton></Tooltip> : null
                            }
                        </div>
                        <Divider/>
                    </>
                    : canEdit
                            ? <div className="solution-feature-card" onClick={()=>{
                                price.setSecondary(new SolutionPrice({eur: '0'}, {en: 'month', es: 'mes', ca: 'mes'}));
                                onUpdate();
                            }}>
                                <div className="solution-feature-icon">
                                    <MaterialIcon icon={'add'}/>
                                </div>
                                <h3>{t('solutions.page.pricing.actions.addSecondary')}</h3>
                            </div> : null
                }
                <ul className="solution-features-list" style={{
                    paddingInlineStart: 0,
                }}>
                    {price.getFeatures().map((feature, index) => <div style={{
                        display: 'flex',
                        flexFlow: 'row',
                        flexWrap: 'nowrap',
                        alignItems: 'center',
                        gap: '5px',
                    }}>
                        <MultilingualEditableText key={index} id="editing-price-primary-period" texts={feature} languages={languages} displayLanguage={language} tag="li" canEdit={canEdit} onSave={(value)=>{
                            price.updateFeature(index, value);
                            onUpdate();
                        }} onStartEditing={onEdit} onEnd={onEndEditing} style={{width: '95%'}}/>
                        <div style={{
                            display: 'flex',
                            flexFlow: 'row',
                            flexWrap: 'nowrap',
                        }}>
                            <Tooltip title={t('actions.moveUp')}><IconButton onClick={index !== 0 ? ()=>{
                                price.moveFeatureUp(index);
                                onUpdate();
                            } : null} disabled={index === 0}><ArrowUpwardOutlined/></IconButton></Tooltip>
                            <Tooltip title={t('actions.moveDown')}><IconButton onClick={index !== price.getFeatures().length-1 ? ()=>{
                                price.moveFeatureDown(index);
                                onUpdate();
                            } : null} disabled={index === price.getFeatures().length-1}><ArrowDownwardOutlined/></IconButton></Tooltip>
                            <Tooltip title={t('actions.delete')}><IconButton onClick={()=>{
                                if (!isEditing) {
                                    price.deleteFeature(index);
                                    onUpdate();
                                } else {
                                    showPopUp();
                                }
                            }}><DeleteOutline/></IconButton></Tooltip>
                        </div>
                    </div>)}
                    {canEdit
                        ? <div className="solution-feature-card" onClick={()=>{
                            price.createFeature();
                            onUpdate();
                        }}>
                            <div className="solution-feature-icon">
                                <MaterialIcon icon={'add'}/>
                            </div>
                            <h3>{t('solutions.page.pricing.actions.addFeature')}</h3>
                        </div> : null
                    }
                </ul>
                <ThemeProvider theme={theme}>
                    <FormControlLabel control={<Checkbox checked={price.getActive()} onChange={(value) => {
                        if (canEdit) {
                            console.log(value.target.checked);
                            price.setActive(value.target.checked);
                            onUpdate();
                        }
                    }}/>} label={t('solutions.page.mostPopular')}/>
                </ThemeProvider>
            </div> : null
        }
    </Dialog>;
}

export function FeatureDialog({ open, onClose, editingFeature, onUpdate, canEdit=true, language='en', onStartEditing, onEndEditing }) {
    return <Dialog 
        open={open}
        onClose={onClose}
        disableEscapeKeyDown
    >
        {open
            ? <>
                <ThemeProvider theme={theme}>
                    <div className="solution-feature-card no-hover">
                            <div className="solution-feature-icon">
                                <EditableMaterilIcon icon={editingFeature.getIcon()} canEdit={canEdit} onChange={(icon) => {
                                    editingFeature.setIcon(icon);
                                    onUpdate();
                                }}/>
                            </div>
                            <h3><MultilingualEditableText id={`feature-title-${editingFeature.getId()}`} texts={editingFeature.getTitle()} languages={['ca', 'en', 'es']} onSave={(value, language) => {
                                editingFeature.setTitle(value);
                                onUpdate();
                            }} onStartEditing={onStartEditing} onEnd={onEndEditing} displayLanguage={language} tag="p" className='solution-tagline'/></h3>
                            <MultilingualEditableText id={`feature-description-${editingFeature.getId()}`} texts={editingFeature.getDescription()} languages={['ca', 'en', 'es']} onSave={(value, language) => {
                                editingFeature.setDescription(value);
                                onUpdate();
                            }} onStartEditing={onStartEditing} onEnd={onEndEditing} displayLanguage={language} tag="p"/>
                        </div>
                </ThemeProvider>
            </>
            : null
        }
    </Dialog>;
}

export function NewFeatureDialog({ open, onClose, onUpdate, solution, featureIdError, setFeatureIdError }) {
    const { t } = useTranslation();

    return <Dialog 
        open={open}
        onClose={onClose}
        disableEscapeKeyDown
    >
        <ThemeProvider theme={theme}>
            <DialogTitle>{t('solutions.page.feature.new')}</DialogTitle>
            <DialogContent sx={{padding: '6px !important'}}>
                <TextField sx={{width: '100%'}} id="new-feature-id" label={t('solutions.page.feature.newId')} variant="outlined" onChange={(value) => {
                    if (value.target.value.match(idRegex) && !solution.containsFeature(value.target.value)) {
                        if (featureIdError) setFeatureIdError(false);
                    } else {
                        if (!featureIdError) setFeatureIdError(true);
                    }
                }} error={featureIdError}/>
            </DialogContent>
            <DialogActions>
                <Button onClick={()=>{
                    if (document.getElementById('new-feature-id').value.match(idRegex) && !solution.containsFeature(document.getElementById('new-feature-id').value)) {
                        solution.createFeature(document.getElementById('new-feature-id').value);
                        onClose();
                        onUpdate();
                    }
                }}>{t('actions.add')}</Button>
            </DialogActions>
        </ThemeProvider>
    </Dialog>;
}

export function SettingsDialog({ solution, open, onClose=()=>{}, onUpdate=()=>{}, onStartEditing=()=>{return true;}, onEndEditing=()=>{}, canEdit=true }) {
    const { t } = useTranslation();

    const [categoriesLeftChecked, setCategoriesLeftChecked] = useState([]);
    const [categoriesRightChecked, setCategoriesRightChecked] = useState([]);

    return <ThemeProvider theme={theme}>
        <Dialog
            open={open}
            onClose={onClose}
            disableEscapeKeyDown
            fullWidth
        >
            <DialogTitle>{t('solutions.page.settings.title')}</DialogTitle>
            <DialogContent>
                <div style={{
                    display: 'flex',
                    flexFlow: 'row',
                    flexWrap: 'nowrap',
                    alignItems: 'center',
                    gap: '5px',
                    width: '100%',
                }}>
                    <div style={{
                        fontSize: '16px',
                        fontWeight: 'bold',
                    }}>{t('solutions.page.settings.id')}: </div>
                    <EditableText id='title' text={solution.getId()} onSave={(value) => {
                        solution.updateId(value);
                        onUpdate();
                    }} onStartEditing={onStartEditing} onEnd={onEndEditing} canEdit={canEdit}/>
                </div>
                <div>
                    <div style={{
                        fontSize: '16px',
                        fontWeight: 'bold',
                    }}>{t('solutions.page.settings.categories')}: </div>
                    <div style={{
                        display: 'flex',
                        flexFlow: 'row',
                        flexWrap: 'nowrap',
                        gap: '15px',
                    }}>
                        <Card
                            style={{width: '100%'}}
                        >
                            <CardHeader
                                sx={{ px: 2, py: 1}}
                                avatar={
                                    <Checkbox
                                        onClick={()=>{}}
                                        checked={false}
                                        indeterminate={
                                            false
                                        }
                                        disabled={false}
                                        slotProps={{
                                            input: {
                                                "aria-label": "primary checkbox",
                                            }
                                        }}
                                    />
                                }
                                title={t('widget.selection.options')}
                                subheader={` selected`}
                            />
                        </Card>
                        <div style={{
                            display: 'flex',
                            flexFlow: 'column',
                            alignItems: 'center',
                            gap: '5px',
                            margin: 'auto 0'
                        }}>
                            <Button
                                sx={{ my: 0.5 }}
                                variant="outlined"
                                size="small"
                                onClick={()=>{}}
                                disabled={categoriesLeftChecked.length === 0}
                                aria-label="move selected right"
                            >
                                &gt;
                            </Button>
                            <Button
                                sx={{ my: 0.5 }}
                                variant="outlined"
                                size="small"
                                onClick={()=>{}}
                                disabled={categoriesRightChecked.length === 0}
                                aria-label="move selected left"
                            >
                                &lt;
                            </Button>
                        </div>
                        <Card
                            style={{width: '100%'}}
                        >
                            <CardHeader
                                sx={{ px: 2, py: 1}}
                                avatar={
                                    <Checkbox
                                        onClick={()=>{}}
                                        checked={false}
                                        indeterminate={
                                            false
                                        }
                                        disabled={false}
                                        slotProps={{
                                            input: {
                                                "aria-label": "primary checkbox",
                                            }
                                        }}
                                    />
                                }
                                title={t('widget.selection.selected')}
                                subheader={` selected`}
                            />
                            <Divider/>
                            <div style={{padding: '0 16px'}}>
                                {solution.getCategories().map((category, index) => <div key={index} style={{
                                    display: 'flex',
                                    flexFlow: 'row',
                                    alignItems: 'center',
                                    gap: '5px',
                                    flexWrap: 'nowrap',
                                    textOverflow: 'clip'
                                }}>
                                    <Checkbox/>
                                    <div>{t(`solutions.categories.${category}`)}</div>
                                </div>)}
                            </div>
                        </Card>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    </ThemeProvider>
}